<script setup lang="ts">
import { toRefs, type StyleValue } from "vue";

export type IconCircleVariant = "info" | "warning";
export type IconCircleSize = "xxs" | "xs" | "sm" | "md" | "lg" | "xl";

interface Props {
  icon?: string;
  variant?: IconCircleVariant;
  size?: IconCircleSize;
  customStyle?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "info",
  size: "md",
});

toRefs(props);

const VARIANT_MAP: Record<IconCircleVariant, string> = {
  info: "bg-darkOcean100",
  warning: "bg-red400 text-white",
};

const toSize = (value: number) => {
  return `${value}px`;
};

const xx = (size: string) => {
  const styles: Partial<StyleValue> = {};
  styles.minHeight = size;
  styles.minWidth = size;
  styles.height = size;
  styles.width = size;

  return styles;
};

const SIZE_MAP: Record<IconCircleSize, string> = {
  xxs: toSize(28),
  xs: toSize(32),
  sm: toSize(40),
  md: toSize(48),
  lg: toSize(60),
  xl: toSize(96),
};

const ICON_SIZE_MAP: Record<IconCircleSize, string> = {
  xxs: "text-sm",
  xs: "text-sm",
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-3xl",
  xl: "text-5xl",
};
</script>

<template>
  <div
    class="rounded-full flex justify-center items-center"
    :class="[customStyle ? customStyle : VARIANT_MAP[variant]]"
    :style="xx(SIZE_MAP[size])"
  >
    <slot>
      <i :class="[icon, ICON_SIZE_MAP[size]]"></i>
    </slot>
  </div>
</template>
